<template>
  <div class="gdp-and-growth-rate">
    <div class="title">
      <span>广东省生产总值及增速</span>
    </div>
    <div class="chart-con">
      <v-chart ref="bar-chart" id="bar-chart" class="bar-chart" :options="chartOption" />
    </div>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartGDPAndGrowth';
import { getGDPAndGrowthData } from '@/api/getChartData';
export default {
  name: 'GDPAndGrowthRate',
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      chartOption: null,
      chartData: null,
    };
  },
  methods: {
    getData() {
      this.$api.screen
        .getGDPGrowth({
          endYear: this.yearP,
        })
        .then((res) => {
          let { data } = res.data;
          let names = [],
            listData = {};
          if (data && data.yData?.length) {
            let fI = 0,
              lI = data.yData[0].data.length;
            names = data.yData.map((item) => {
              listData[item.name] = item.data;
              // const firstIndex = item.data.findIndex((x) => x !== null && x !== '');
              // const lastIndex = item.data.findLastIndex((x) => x !== null && x !== '') + 1;
              // if (firstIndex !== -1 && firstIndex > fI) fI = firstIndex;
              // if (lastIndex !== -1 && (lI === item.data.length || lastIndex > lI)) lI = lastIndex;
              return item.name;
            });
            listData['年份'] = data.xData;
            for (const key in listData) {
              if (Object.hasOwnProperty.call(listData, key)) {
                const element = listData[key];
                listData[key] = element.slice(fI, lI);
              }
            }
          }
          let list = {
            yAxis: {
              names: ['单位：亿元', '单位：%'],
            },
            names,
            data: [],
          };
          for (let i = 0; i < listData['年份'].length; i++) {
            let obj = {
              年份: listData['年份'][i],
            };
            for (let key in listData) {
              obj[key] = listData[key][i];
            }
            list.data.push(obj);
          }
          this.chartData = list;
          console.log(444, list);
          this.chartOption = drawBar(list);
        });

      // getGDPAndGrowthData().then(res => {
      //   let year = new Set();
      //   let names = new Set();
      //   let data = [];
      //   res.RECORDS.map((item) => {
      //     // year.add(item['年份']);
      //     names.add(item['指标']);
      //     // data.push(item['总额'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         names: ['单位：亿元', '单位：%']
      //       },
      //       names: Array.from(names),
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let data = {};
      //     data.year = this.filterData(res.RECORDS, '', '指标', false, true);
      //     data.GDP = this.filterData(res.RECORDS, '地区生产总值', '指标');
      //     data.growthRate = this.filterData(res.RECORDS, '增速', '指标', true);
      //     // data.GDP = this.filterData(res.RECORDS, '地区生产总值', '总额', '类型');
      //     // data.growthRate = this.filterData(res.RECORDS, '增值', '总额', '类型');
      //     console.log(data, '-d')
      //     for (let i = 0; i < data.year.length; i++) {
      //       list.data.push({
      //         年份: data.year[i],
      //         地区生产总值: data.GDP[i],
      //         增值: data.growthRate[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, label, percent, year) {
      let arr = [];
      if (year) {
        for (let key in data[0]) {
          key !== label ? arr.push(key) : '';
        }
      } else {
        let obj = data.filter((item) => item[label] === name)[0];
        for (let key in obj) {
          if (key !== label) {
            obj[key] = percent ? Math.round(obj[key] * 100 * 100) / 100 : obj[key];
            arr.push(obj[key]);
          }
        }
      }
      return arr;
    },
    // filterData(data, name, keyName, label) {
    //   let arr = [];
    //   for (let key = 0; key < data.length; key++) {
    //     if (data[key][label] === name) {
    //       arr.push(Number(data[key][keyName]));
    //     }
    //   }
    //   return arr;
    // },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.gdp-and-growth-rate {
  .chart-box();
}
</style>
